// @flow strict

import type { Group } from '@ansarada/ace-react/dist/ace/components/Select2/Select2.types';
import * as React from 'react';
import {
  Button,
  FormGrid,
  FormGridCell,
  FormGridRow,
  Select2,
  TextArea,
} from '@ansarada/ace-react';
import FormattedContent from '../../../../internal/FormattedContent';
import OnBoardingLayout from '../OnBoardingLayout';
import OutcomeText from './OutcomeText';
import styles from './styles.scss';

type PropsType = {|
  title: string,
  onBack?: () => void,
  onNext: () => void,
  additionalInformationPlaceholder: string,
  question1: string,
  question2: string,
  question2Part2: string,
  question2Part3: string,
  question3: string,
  additionalInformationLabel: string,
  additionalInformationValue: string,
  setAdditionalInformationValue: string => void,
  bgMobile: string,
  bgDesktop: string,
  isSubmitting: boolean,
  onGoToFirstQuestion?: () => void,
  isFromReferrer: boolean,
  question1Title: string,
  question1Placeholder: string,
  question1Options: Array<Group>,
  customerType: string,
  setCustomerType: string => void,
|};

const PureQuestionSubmit = ({
  title,
  onBack,
  onNext,
  additionalInformationPlaceholder,
  question1,
  question2,
  question2Part2,
  question2Part3,
  question3,
  additionalInformationLabel,
  additionalInformationValue,
  setAdditionalInformationValue,
  bgMobile,
  bgDesktop,
  isSubmitting,
  onGoToFirstQuestion,
  isFromReferrer,
  question1Title,
  question1Placeholder,
  question1Options,
  customerType,
  setCustomerType,
}: PropsType) => {
  return (
    <OnBoardingLayout
      title={title}
      actionButtons={[
        !isFromReferrer && (
          <Button key="back" onClick={onBack} id="s7-back">
            Back
          </Button>
        ),
        <Button
          key="next"
          onClick={onNext}
          variant="Primary"
          className={styles.submitBtn}
          disabled={!question1 && !customerType}
          loading={isSubmitting}
          id="s7-start"
        >
          Start my free trial
        </Button>,
      ]}
      bgMobile={bgMobile}
      bgDesktop={bgDesktop}
    >
      {!isFromReferrer && (
        <div className={styles.confirmationContainer}>
          <FormattedContent>
            <OutcomeText
              question1={question1}
              question2={question2}
              question2Part2={question2Part2}
              question2Part3={question2Part3}
              question3={question3}
            />
          </FormattedContent>
          {question2 !== 'Other' && (
            <div className={styles.editContent}>
              <FormattedContent>
                Does this sound right?{' '}
                <Button size="Medium" variant="Link" onClick={onGoToFirstQuestion} id="s7-edit">
                  Edit details
                </Button>
              </FormattedContent>
            </div>
          )}
        </div>
      )}

      <FormGrid>
        {// $FlowFixMe FromGrid doesn't accept boolean or undefined
        isFromReferrer && (
          <FormGridRow>
            <FormGridCell labelText={question1Title}>
              <Select2
                id="s7-work-area"
                size="Medium"
                placeholder={question1Placeholder}
                value={customerType}
                options={question1Options}
                onChange={option => setCustomerType(option.value)}
              />
            </FormGridCell>
          </FormGridRow>
        )}
        <FormGridRow>
          <FormGridCell labelId="s7-other" labelText={additionalInformationLabel}>
            <TextArea
              id="s7-other"
              placeholder={additionalInformationPlaceholder}
              value={additionalInformationValue}
              onChangeValue={setAdditionalInformationValue}
              maxLength={250}
            />
          </FormGridCell>
        </FormGridRow>
        <FormGridRow>
          <FormGridCell>
            <FormattedContent className={styles.footer}>
              <div>
                <span>By signing up, you agree to our </span>
                <a
                  href="https://www.ansarada.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                <span>, </span>
                <a
                  href="https://www.ansarada.com/terms-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions
                </a>
                <span> and </span>
                <a href="https://www.ansarada.com/gdpr" target="_blank" rel="noopener noreferrer">
                  GDPR information
                </a>
                <span>. </span>
              </div>
              <br />
              <div>
                This site is protected by reCAPTCHA and the Google{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>{' '}
                apply.
              </div>
            </FormattedContent>
          </FormGridCell>
        </FormGridRow>
      </FormGrid>
    </OnBoardingLayout>
  );
};

export default PureQuestionSubmit;
